import { ReactNode } from 'react';
import { css } from '@linaria/atomic';
import { theme } from '@frontend/theme';
import { Heading } from '../../../';
import { IconButton } from '../../../';
import { XIcon } from '../../../../icon';
import { TableCommonStyles } from '../../common-styles';

const filterSidebarHeadingStyle = css`
  margin: 0;
  padding: ${theme.spacing(0.5)};
  line-height: ${theme.spacing(3)};
`;

const filterSidebarIconButtonStyle = css`
  height: 36px;
  width: 36px;
  min-width: 36px;
`;

type ClickHandler = (event?: React.PointerEvent | React.FormEvent) => void | Promise<void>;

type FilterSidebarHeaderProps = {
  closeFilterSidebar: ClickHandler;
  filterSidebarHeaderLabel?: ReactNode;
};

export const FilterSidebarHeader = ({ closeFilterSidebar, filterSidebarHeaderLabel }: FilterSidebarHeaderProps) => {
  const sidebarHeaderStyles = TableCommonStyles.tableFilterStyles({
    type: 'filterSidebarHeader',
  });

  return (
    <header css={sidebarHeaderStyles}>
      <Heading className={filterSidebarHeadingStyle} level={3}>
        {filterSidebarHeaderLabel ?? 'Filter Results'}
      </Heading>
      <IconButton onClick={closeFilterSidebar} label='Close Filters' className={filterSidebarIconButtonStyle}>
        <XIcon />
      </IconButton>
    </header>
  );
};
